import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerModule, ButtonModule } from '@xref/xref-lib';

import { XrefApiKeyManageModalComponent } from './xref-api-key-manage-modal.component';

@NgModule({
  declarations: [XrefApiKeyManageModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    BannerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [XrefApiKeyManageModalComponent],
})
export class XrefApiKeyManageModalModule {}
